import ET3Div from "../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import Et3Margin from "../../../../../core/et3-ui/ET3Margin";
import PaidUserInformation from "./PaidUserInformation";
import PaidUsersPicker from "./PaidUsersPicker";

const PaidUserSelect = withLiteObserverAndTheme(
  ({ showCount }: { showCount: boolean }) => {
    return (
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="row"
        justifyContent="flex-start"
        alignItems="flex-start"
        withShadow={false}
        width={1510}
        height={80}
        color={""}
        style={{}}
        onClick={() => {}}
      >
        <PaidUsersPicker showCount={showCount} />
        <Et3Margin top={0} bottom={0} left={20} right={0} />
        <PaidUserInformation />
      </ET3Div>
    );
  }
);

export default PaidUserSelect;
